export class DialogModelNewManufacture {
    constructor(
      public data:any
    ) {}
  }